import React from 'react'
import { Card, Button } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import HelperMetiers360 from '../../services/HelpersMetiers360';
import { useStoreState } from "easy-peasy";
import AuthorizationChecker from "../../services/AuthorizationChecker.js";
import { showDuration } from './ActivityDetailsComponent.jsx';

import './MiniCardActivityComponent.scss';

const CardWrapperLink = ({ isLink, readOneSlug, children, onClickItem, mediaUniqueId, ...rest }) => {
    const location = useLocation();
    const navigate = useNavigate();

    return <Card onClick={() => navigate(readOneSlug, { state: { olderSearchParams: location.search } })} {...rest}>
        {children}
    </Card>;
}

const MiniCardActivityComponent = ({ activity, readOneSlug, createBlacklistModal }) => {

    const { apiData: { BACKOFFICE_DEFAULT_VALUES } } = useStoreState(state => state.actionSlugs);
    const { activityStatus } = BACKOFFICE_DEFAULT_VALUES;

    return (
        <CardWrapperLink
            className={"activity-card activity-border-radius-round"}
            readOneSlug={readOneSlug}
            mediaUniqueId={activity.uniqueId}
        >
            <Card.Body className="card_body card_body_with_infos">
                {!AuthorizationChecker.hasUpdateRights('activity') && <>
                    <div className='list-status'>
                        {activity?.isBlackListed ? "Non affichée" : "Affichée"}
                    </div>
                    <div className='list-action'>
                        <Button variant={activity?.isBlackListed ? 'success' : 'danger'} className='blacklist-button' size='sm' onClick={(e) => {
                            e.stopPropagation();
                            createBlacklistModal(activity);
                        }}>
                            {activity?.isBlackListed ? 'Afficher' : 'Retirer'}
                        </Button>
                    </div>
                </>}
                <Card.Img src={activity.thumbnail} />

                <Card.Title className="card_title">{activity.title}</Card.Title>
            </Card.Body>
            <Card.Footer>
                <div className="status-date">
                    {
                        activity.publishedAt ?
                            HelperMetiers360.getdisplayDateType(activity.publishedAt, 'day')
                            : activity.status == 'lab' ?
                                'En test LAB'
                            : activityStatus?.find(st => st.value == activity.status)?.label
                    }
                </div>
                {activity.duration && <div className="activity-duration" dangerouslySetInnerHTML={{ __html: showDuration(activity) }}>
                </div>}
            </Card.Footer>
        </CardWrapperLink>
    )
}

export default MiniCardActivityComponent